export const configs = {
  authenticatedRoute: '/home',
  unauthenticatedRoute: '/login',
};
